export { ReactComponent as ContactPlusHeaderLogo } from './header-logo.svg';
